import {
  getAllUserPayments,
  returnOrder,
  getAllOrders,
  returnPre,
  returnPreConfirm,
  returnOrderConfirm,
  preInvalidRefund,
  preInvalidRefundConfirmed,
  invalidRefundConfirmed,
  orderBankReturn,
} from "@/services/student-payments.service";

import { setPaginationDetails } from "@/utils/utils";
import moment from "moment"
// initial state
const state = () => ({});

// mutations
const mutations = {};

// actions
const actions = {
  async loadAllOrders(vuexContext, co) {
    return await getAllOrders(co).then((response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;
      items.map((val, index) => {
        val.index = index + 1;
        val.totalPrice = val.price + " " + val.currencyCode;
        val.orderContractPath = process.env.VUE_APP_CDN + "uploads/Order/" + val.orderContractPath;
        val.fullName = val.firstName + " " + val.lastName;
        const orderDate = moment(val.orderDate);
        const sixteenDaysAgo = moment().subtract(16,'days');
        val.refundable = orderDate.isSameOrAfter(sixteenDaysAgo, 'day');

      });
      setPaginationDetails(co, totalCount, totalPages);
      return items;
    });
  },
  async loadAllUserPayments() {
    return await getAllUserPayments().then((response) => {
      let data = response.data.data;
      data.map((val) => {
        val.totalPrice = val.price + " " + val.currencyCode;
        val.orderContractPath = process.env.VUE_APP_CDN + "uploads/Order/" + val.orderContractPath;
      });
      return data;
    });
  },
  async returnOrder(vuexContext, value) {
    return await returnOrder(value).then((response) => {
      let data = response.data.data;
      return data;
    });
  },
  async returnPre(vuexContext, value) {
    return await returnPre(value).then((response) => {
      let data = response.data.data;
      return data;
    });
  },
  async returnPreConfirm(vuexContext, value) {
    return await returnPreConfirm(value).then((response) => {
      let data = response.data.data;
      return data;
    });
  },
  async orderBankReturn(vuexContext, value) {
    //console.log("val",value);
    return await orderBankReturn(value).then((response) => {
      let data = response.data.data;
      return data;
    });
  },
  async returnOrderConfirm(vuexContext, value) {
    return await returnOrderConfirm(value).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async preInvalidRefund(vuexContext, value) {
    return await preInvalidRefund(value).then((response) => {
      let data = response.data.data;
      return data;
    });
  },
  async preInvalidRefundConfirmed(vuexContext, value) {
    return await preInvalidRefundConfirmed(value).then((response) => {
      let data = response.data.data;
      return data;
    });
  },
  async invalidRefundConfirmed(vuexContext, value) {
    return await invalidRefundConfirmed(value).then((response) => {
      let data = response.data.data;
      return data;
    });
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
